import App from './application-container';
import { show_modal, hide_modal } from './modals';
import * as state_helpers from './set-button-state';
import { update_dom_text_values_and_coordinates } from './utility';
import { uid_deselect_all_objects, uid_hide_rigid_move_manipulator, uid_toggle_edge_tangent_manipulators } from './ui_display';
import { hide_floating_toolbar } from '../../../../src/features/floating-toolbar'

export function show_search_modal() {
  // Hide rigid move manipulator if visible
  if (uid_state.edge_tangent_manipulators_are_shown)
      uid_toggle_edge_tangent_manipulators();
  else if (App.state.rigid_move_manipulator) {
      uid_hide_rigid_move_manipulator(false, 0, true);
      uid_deselect_all_objects();
  }

  show_modal("searchModal", true);
}

export function hide_search_modal() {
  if (App.state.modal.searchModal)
    hide_modal("searchModal", true);
}

// Set status of UI elements
export function enable_ui_element(selector, fn, propagate=true) {
    const elem = document.querySelector(selector);
    if (!elem) return;

    elem.classList.remove('active');
    elem.classList.remove('disabled');
    elem.parentElement.classList.remove('hidden');
    //elem.prop('disabled', false);

    // Augment function to also close floating toolbar
    const settings_selector = selector + "-settings-wrapper";
    const settings_elem = document.querySelector(settings_selector);
    if (settings_elem)
        settings_elem.onclick = () => {
            hide_floating_toolbar();
            hide_search_modal();
            fn();
            settings_elem.blur();
        };
    else
        elem.onclick = () => {
            hide_floating_toolbar();
            hide_search_modal();
            fn();
            elem.blur();
        };
}

export function disable_ui_element(selector, propagate=true) {
    const elem = document.querySelector(selector);
    if (!elem)
        return;

    const settings_selector = selector + "-settings-wrapper";
    const settings_elem = document.querySelector(settings_selector);
    if (settings_elem)
        settings_elem.onclick = () => settings_elem.blur();
    else
        elem.onclick = () => elem.blur();

    elem.classList.remove("active");
    elem.classList.add("disabled");
    elem.parentElement.classList.add("disabled");
    //elem.prop('disabled', true);
}

export function select_ui_element(selector, fn, propagate=true) {
    const elem = document.querySelector(selector);
    if (!elem)
        return;

    elem.classList.add('active');
    // elem.prop('disabled', false);
    elem.classList.remove('disabled');
    elem.parentElement.classList.remove('hidden');
    const settings_selector = selector + '-settings-wrapper';
    const settings_elem = document.querySelector(settings_selector);
    if (settings_elem)
        settings_elem.onclick = () => {
            hide_floating_toolbar();
            hide_search_modal();
            fn();
            settings_elem.blur();
        };
    else
        elem.onclick = () => {
            hide_floating_toolbar();
            hide_search_modal();
            fn();
            elem.blur();
        }
}

export function deselect_ui_element(elem, fn, propagate=true) {
    enable_ui_element(elem, fn, propagate);
}

export function set_button_states() {
  if (animation_is_suppressed() || uid_in_dragging_mode || App.state.dragging_type != "none" || App.state.rotating)
    return;

  update_dom_text_values_and_coordinates();

  state_helpers.inflate_deflate();

  // Set also infotext state if necessary
  display_message_to_user_if_necessary();

  // Check for zero-thickness faces
  setup_checking_for_zero_thickness_faces(null);
  check_for_zero_thickness_faces();

}

export function has_reference_objects() {
    return uid_reference_vertices.length > 0
        || uid_reference_edges.length > 0
        || uid_reference_faces.length > 0;
}

export function has_selected_objects() {
    return uid_selected_vertices.length > 0
        || uid_selected_edges.length > 0
        || uid_selected_faces.length > 0;
}
